import { Alert } from "antd";
import React, { useEffect, useRef, useState } from "react";
const FMLCheckingDialog = (props) => {
const [warnings, setWarnings] = useState([]);

  useEffect(() => {
    if (!!props.project?.fmlChecking) {
      let warnings = (JSON.parse(props.project?.fmlChecking || [])?.warnings || [])
              .filter(w => w.visible == true);
      setWarnings(warnings);
    }
  }, [props.project]);

  return (
    <React.Fragment>
      <div className="space-y-2">
        {warnings.length === 0 && (
          <div className="p-3">
            <Alert severity="info" message="No issues found in FML checking."
              showIcon
              style={{
                marginBottom: "10px",
                borderRadius: "12px",
              }} />
          </div>)
        }
        {warnings.map((w, i) => (
          <div
            key={i}
            className="flex items-start gap-2 p-3 "
          >
            <Alert
              message={
                <div style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                  <div style={{ fontWeight: 600 }}>{w.message}</div>

                  {w.sample && (
                    <div style={{ fontSize: "12px", color: "#999" }}>
                      Sample: {w.sample}
                    </div>
                  )}

                  <div style={{ fontSize: "12px", color: "#999" }}>
                    [{w.id}]
                  </div>
                </div>
              }
              type={w.severity === "error" ? "error" : "warning"}
              showIcon
              style={{
                marginBottom: "10px",
                width: "600px",
                borderRadius: "12px",
              }}
            />

          </div>

        ))}
      </div>
    </React.Fragment>
  );
};
export default FMLCheckingDialog;
